import moment from "moment";
import momentTz from "moment-timezone";
import { createSlice, createAction } from "@reduxjs/toolkit";
import { fetchSchedules } from "../services/schedule";
//import { fetchTimeOffset, fetchAppSettingByID } from "../services/userSettings";
import { determineEventColor, determineEndTime } from "../domain/calendar";
import { determineStateIcon, determineModalityIcon } from "../domain/icons";
//import { userSettingsActions } from ".";

const initialState = {
  isLoading: false,
  error: null,
  data: [],
  //durationValue: "",
  //offset: "",
};

const schedule = createSlice({
  name: "schedule",
  initialState,
  reducers: {
    fetchStarted: (state) => {
      state.isLoading = true;
    },
    fetchFulfilled: (state, action) => {
      state.isLoading = false;
      state.data = action.payload.items;
      state.total = action.payload.total;
      state.durationIncrement = action.payload.durationIncrement;
      state.timeIncrement = action.payload.timeIncrement;
      //state.offset = action.payload.settingvalue;
      state.error = null;
    },
    fetchRejected: (state, action) => {
      const serialized = JSON.stringify(action.payload);
      state.isLoading = false;
      state.error = action.payload.toString();
    },
  },
});

// fetch schedules Thunk
const fetch = (query) => async (dispatch, getState) => {
  const { fetchStarted, fetchFulfilled, fetchRejected } = schedule.actions;
  //const durationIncrement = getState().userSettings.appSetting.value;
  //const durationIncrement = () => {
  // const durationSetting = getState().userSettings.appSetting.find(
  //   (setting) => setting.id === 376
  // );

  // const durationIncrement = Number(durationSetting.value);

  // const timeSetting = getState().userSettings.appSetting.find(
  //   (setting) => setting.id === 36
  // );

  // const timeIncrement = Number(timeSetting.value);

  dispatch(fetchStarted());
  try {
    const res = await fetchSchedules(query);
    const durationSetting = getState().userSettings.appSetting.find(
      (setting) => setting.id === 376
    );
    const durationIncrement = Number(durationSetting.value);

    const timeSetting = getState().userSettings.appSetting.find(
      (setting) => setting.id === 36
    );
    const timeIncrement = Number(timeSetting.value);
    dispatch(fetchFulfilled({ ...res, durationIncrement, timeIncrement }));
    //dispatch(fetchFulfilled({ ...res, durationIncrement }));
  } catch (err) {
    dispatch(createAction(fetchRejected(err.toString())));
  }
};

export const actions = {
  ...schedule.actions,
  fetch,
};

// selectors;
export const isScheduleLoading = (state) => state.isLoading;
export const getSchedule = (state) => state.data;
export const getScheduleError = (state) => state.error;
export const getEvents = (state) => {
  const durationValue = state.durationIncrement;
  const timeOffset = state.timeIncrement;
  return (
    durationValue,
    timeOffset,
    state.data.map((item) => {
      const {
        appointmentTypeYearNumber,
        appointmentLocation,
        startTime,
        negativeOffsetStartTime,
        pacificTime,
        appointmentDuration,
        modalityID,
        modalityCode,
        apptState,
        apptAction,
      } = item;

      //const offset = Number(state.offset);

      const title = appointmentTypeYearNumber;
      const modality = modalityCode;
      const location = appointmentLocation;
      const duration = appointmentDuration;
      const state = apptState;
      const action = apptAction;
      const start = moment(pacificTime).toDate();
      // const start = momentTz
      //   .tz(startTime, "America/Los_Angeles").toDate()
      //.format();

      //const start = moment(negativeOffsetStartTime).toDate();
      // const end = moment(start)
      //   .add(Number(appointmentDuration), "h")
      //   .toDate();
      const allday = false;
      const end = determineEndTime(durationValue, duration, start);

      //const color = determineEventColor(modality);
      const color = determineEventColor(state, action);
      const stateIcon = determineStateIcon(state, action);
      const modalityIcon = determineModalityIcon(modality);

      return {
        title,
        location,
        start,
        end,
        allday,
        color,
        modality,
        duration,
        stateIcon,
        modalityIcon,
      };
    })
  );
};
export default schedule.reducer;
